import React from "react";
import { STATUS_STYLES } from "../lib/statusConfig";
import { useColors } from "../context/ColorContext";

export function StatusBadge({ status, size = "sm" }) {
  const colors = useColors();
  const s = colors ? colors.statusStyle(status) : (STATUS_STYLES[status] || STATUS_STYLES["Pending Submission"]);
  return (
    <span
      data-testid={`status-badge-${(status || "").replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
      className={`inline-flex items-center gap-1.5 rounded-sm border font-medium whitespace-nowrap ${
        size === "sm" ? "text-xs px-2 py-0.5" : "text-sm px-2.5 py-1"
      }`}
      style={{ backgroundColor: s.bg, color: s.text, borderColor: s.border }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: s.dot }} />
      {status}
    </span>
  );
}

export function DisciplineTag({ discipline }) {
  const colors = useColors();
  const s = colors
    ? colors.disciplineStyle(discipline)
    : (!discipline || discipline === "N/A"
        ? { bg: "#F4F4F5", text: "#71717A", border: "#E4E4E7" }
        : { bg: "#EEF2FF", text: "#4338CA", border: "#E0E7FF" });
  return (
    <span className="inline-flex text-xs px-2 py-0.5 rounded-sm font-medium border"
      style={{ backgroundColor: s.bg, color: s.text, borderColor: s.border }}>
      {discipline || "N/A"}
    </span>
  );
}
